import './discrete-select.scss'

import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { DISCRETE_SELECT_OPTION_SELECTED } from '../../events';

interface Option {
    value: number,
    text: string,
}

export const DiscreteSelect = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        options: {
            type: Array as PropType<Option[]>
        },
        dataCy: {
            type: String,
        },
    },
    template: require('./discrete-select.html'),
    data() {
        return {
            selectedOption: -1, // differs from mounted()'s reset to 0, so the watch below fires on load
        }
    },
    watch: {
        selectedOption() {
            this.$emit(DISCRETE_SELECT_OPTION_SELECTED, this.selectedOption)
        },
    },
    mounted() {
        this.selectedOption = 0
    },
})
